// Basic SVG Animation - Clean Production Version
document.addEventListener( 'DOMContentLoaded', function() {
  // Find sections
  const sections = document.querySelectorAll( '.e-stn--progress-line-animation' );
  
  sections.forEach( function( section ) {
    // Find SVG in this section
    const line1 = section.querySelector( '.careers-line-1 svg path' );
    const line2 = section.querySelector( '.careers-line-2 svg path' );
    
    // Setup paths
    if ( line1 ) {
      const length1 = line1.getTotalLength();
      line1.style.strokeDasharray = length1 + 'px';
      line1.style.strokeDashoffset = length1 + 'px';
    }
    
    if ( line2 ) {
      const length2 = line2.getTotalLength();
      line2.style.strokeDasharray = length2 + 'px';
      line2.style.strokeDashoffset = length2 + 'px';
    }
    
    // Scroll animation
    let ticking = false;
    
    function animate() {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Animation range
      const animationStart = windowHeight * 0.7;
      const animationEnd = windowHeight * 0.1;
      const animationRange = animationStart - animationEnd;
      
      let progress = 0;
      if ( rect.top < animationStart && rect.top > animationEnd ) {
        progress = Math.max( 0, Math.min( 1, ( animationStart - rect.top ) / animationRange ) );
      } else if ( rect.top <= animationEnd ) {
        progress = 1;
      }
      
      // Animate lines
      if ( line1 ) {
        const length1 = line1.getTotalLength();
        const offset1 = length1 * ( 1 - progress );
        line1.style.strokeDashoffset = offset1 + 'px';
      }
      
      if ( line2 ) {
        const length2 = line2.getTotalLength();
        const offset2 = length2 * ( 1 - progress );
        line2.style.strokeDashoffset = offset2 + 'px';
      }
      
      ticking = false;
    }
    
    function onScroll() {
      if ( !ticking ) {
        requestAnimationFrame( animate );
        ticking = true;
      }
    }
    
    window.addEventListener( 'scroll', onScroll );
  } );
} );